import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    backgroundColor: tokens.colorNeutralBackground1,
    // Page shell must be able to grow past one viewport: a fixed height clamps
    // the box while content overflows, letting the shared footer overlap it.
    minHeight: "100vh",
    // Prefer the dynamic viewport unit when supported so mobile browser chrome
    // doesn't add a phantom scroll. Falls back transparently to 100vh on
    // Safari < 15.4, Chromium < 108, Firefox < 101.
    "@supports (min-height: 100dvh)": {
      minHeight: "100dvh",
    },
  },
  main: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "stretch",
    ...shorthands.padding("24px", "0px", "20px", "0px"),
    ...shorthands.gap("6px"),
    backgroundColor: tokens.colorNeutralBackground1,
    "@media (min-width: 500px)": {
      // Fill the shell rather than measuring against it: a percentage height
      // resolves to `auto` under a min-height parent, so the region would
      // collapse to its content instead of stretching.
      flexGrow: 1,
      alignItems: "stretch",
      backgroundColor: tokens.colorNeutralBackground2,
    },
  },
  subMainContainer: {
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 500px)": {
      ...shorthands.padding("16px", "16px", "24px", "16px"),
      ...shorthands.borderRadius("8px"),
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: tokens.shadow2,
      // Absorb the leftover space instead of pinning to the viewport. The card
      // scrolls internally, so it must be free to shrink below its content
      // height -- hence the explicit minHeight reset for the flex item.
      flexGrow: 1,
      minHeight: 0,
      ...shorthands.overflow("hidden"),
    },
    "@media (min-width: 500px) and (max-width: 899px)": {
      marginLeft: "40px",
      marginRight: "40px",
      maxWidth: "100%",
    },
    "@media (min-width: 900px) and (max-width: 1239px)": {
      ...shorthands.margin("0px", "auto"),
      width: "840px",
    },
    "@media (min-width: 1240px) and (max-width: 1399px)": {
      marginLeft: "200px",
      marginRight: "200px",
      maxWidth: "100%",
    },
    "@media (min-width: 1400px)": {
      ...shorthands.margin("0px", "auto"),
      width: "1040px",
    },
  },
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    ...shorthands.padding("0"),
    ...shorthands.margin("-1px"),
    ...shorthands.overflow("hidden"),
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    ...shorthands.borderWidth("0"),
  },
});
